import { Injectable } from '@angular/core';
import { CONFIG } from "../../config/config";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SalesPointsService {

  constructor(
    public http: HttpClient,
    public router: Router,
  ) { }

  getAllSalesPoints() {
    return this.http.get(`${CONFIG.API_PROD}sales_points`)
  }
  
}